import Modal from "../../components/Base/Modal";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { useForm } from "react-hook-form";
import LoadingSpinner from "../../components/LoadingSpinner";
import * as Yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorViewer from "../../components/ErrorViewer";
import Required from "../../components/Required";
import { EmployerinformationI } from "../../interfaces";
import { GetAllEmployerBranch, GetDocumentDefinitions, UpdateEmployerDetails } from "../../redux/selfService/selfServiceSlice";
import SuccessModal from "../../components/SuccessModal";
import EmployerSelect from "../../components/EmployerSelect";
import { FiX } from "react-icons/fi";
import { useDropzone } from 'react-dropzone'; // Import the useDropzone hook
import './change-employer-style.scss'

interface PropsI {
  showModal: boolean;
  onClose: () => void;
  employer: any;
}

const ChangeEmployerBranch = ({ showModal, onClose, employer }: PropsI) => {
  const dispatch = useAppDispatch();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const { allEmployerBranch, allEmployer, isLoading } = useAppSelector((state) => state?.selfService);
  const { user } = useAppSelector((state) => state?.auth);
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [selectedEmployer, setSelectedEmployer] = useState<number | null>(user.employerId); // Initialize with user's employerId
  const [selectedEmployerName, setSelectedEmployerName] = useState<string>(""); // Add this variable

  const { allDocumentDefinitions } = useAppSelector((state) => state?.selfService);

  const [fileTypes, setFileTypes] = useState<string[]>([]);
  const toggleSuccessModal = () => setShowSuccessModal(!showSuccessModal);

  const validationSchema = Yup.object().shape({
    employerId: Yup.number(),
    employerBranchId: Yup.string().required("Please select employer branch"),
    Document1: null,
  });

  const {
    handleSubmit, register, setValue, trigger,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      employerId: selectedEmployer, // Use selectedEmployer as the default value
      employerBranchId: employer.employerBranchId,
      Document1: null,
    },
  });

  useEffect(() => {
    if (uploadedFiles.length > 0) {
      for (let i = 0; i < uploadedFiles.length; i++) {
        setValue(`Document1.${(i + 1).toString()}`, uploadedFiles[i]);
      }
    } else {
      setValue("Document1", null);
    }

    trigger("Document1");

    

  }, [uploadedFiles]);


  useEffect(() => {
   
    if (selectedEmployer) {
      dispatch(GetAllEmployerBranch({ employerId: selectedEmployer }));
      // dispatch(GetDocumentDefinitions({ searchText: selectedEmployer?.toString() }));
    }

    
  }, [ selectedEmployer]);


   // Call GetDocumentDefinitions action once on component mount
   useEffect(() => {
    dispatch(GetDocumentDefinitions({ searchText: "Employers" }));
   // dispatch(GetDocumentDefinitions({ searchText: "" }));
  }, []); // Empty dependency array ensures this runs once


  const onSubmit = async (values: any, e: any) => {
    e.preventDefault();


    
  // Check if any file type is not selected
  if (fileTypes.some((type) => type === "")) {
    alert("Please select file types for all uploaded documents.");
    return; // Exit early if not all file types are selected
  }

  
    let formData = new FormData();
   // formData.append("employerId", values.employerId?? employer.employerId);

  //  console.log('XXXXXXXXXXXXX1',employer);
  //  console.log('XXXXXXXXXXXXX2',values);
    formData.append("employerId", values.employerId === '0' ? employer.employerId : values.employerId);

    formData.append("employerBranchId", values.employerBranchId);

    for (let i = 0; i < uploadedFiles.length; i++) {

   
      formData.append(`Documents[${i}].documentDefinitionId`, fileTypes[i]);
      formData.append(`Documents[${i}].file`, uploadedFiles[i]);
    }

    const updateAction = await dispatch(UpdateEmployerDetails(formData));
    console.log(updateAction);
    if (updateAction?.type === "selfService/UpdateEmployerDetails/fulfilled" && updateAction?.payload?.statusCode === "00") {
      toggleSuccessModal();
    }
  };

  // const addFilesForUpload = (acceptedFiles: File[]) => {
  //   setUploadedFiles(prevFiles => [...prevFiles, ...acceptedFiles]);
  // }

  const addFilesForUpload = (acceptedFiles: File[]) => {
    setUploadedFiles((prevFiles) => [...prevFiles, ...acceptedFiles]);
    setFileTypes((prevFileTypes) =>
      prevFileTypes.concat(Array(acceptedFiles.length).fill(""))
    ); // Initialize file types with empty strings
  };

  const removeFile = (file: File, index: number) => {
    setUploadedFiles((prevFiles) =>
      prevFiles.filter((prevFile, prevIndex) => prevIndex !== index)
    );
  
    setFileTypes((prevFileTypes) =>
      prevFileTypes.filter((prevFileType, prevIndex) => prevIndex !== index)
    );
  };
  

  // Use the useDropzone hook to handle file drops
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: addFilesForUpload,
    accept: {
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/png': ['.png'],
      'application/pdf': ['.pdf'],
      // Add more formats as needed
    },
    multiple: true, // Allow multiple file uploads
  });

  return (
    <>
      {!showSuccessModal ? (
        <Modal
          showModal={showModal}
          onClose={onClose}
          className="transaction-summary-modal rounded-full"
        >
          <div className="modal-body rounded-b-xl">
            <h3>
              Change Employer or Employer Branch
            </h3>
            <div className="form__group">
              <label htmlFor="employerId" className="form__label">
                Employer <Required />
              </label>
              <EmployerSelect
                defaultValue={
                  selectedEmployer
                    ? {
                        value: selectedEmployer as any,
                        label: selectedEmployerName, // Set the selected employer name
                      }
                    : {
                      value: employer.employerId,
                      label: employer.employerName,
                    }
                }
                onChange={(val) => {
                  setSelectedEmployer(val.value.id);
                  setSelectedEmployerName(val.value.txtemployername); // Update selected employer name
                  setValue("employerId", val.value.id);
                }}
              />
              {errors.employerId && (
                <ErrorViewer message={errors.employerId.message as string} />
              )}
            </div>
            <div className="form__group">
              <label htmlFor="branch" className="form__label">
                Branch <Required />
              </label>
              <select id="branch" className="form__select" {...register("employerBranchId")} >
                <option value={employer.employerBranchId}>{employer.employerBranchName}</option>
                {allEmployerBranch && allEmployerBranch.length > 0 && allEmployerBranch.map((branch) =>
                  <option value={branch.id} key={branch.id}>{branch.txtEmployerBranchName}</option>
                )}
              </select>
              {errors.employerBranchId && (
                <ErrorViewer message={errors.employerBranchId.message as string} />
              )}
            </div>
            <div className="form__group">
              <ul className="my-3">
                <label htmlFor="lastName" className="form__label">
                  Documents
                </label>
                {uploadedFiles.map((file, index) => (
                  <li className="flex items-center" key={index}>
                    <div>{file.name}</div>
                    <select
                      className="form__select ml-4"
                      value={fileTypes[index]}
                      
                      onChange={(e) => {
                        const updatedFileTypes = [...fileTypes];
                        updatedFileTypes[index] = e.target.value;
                        setFileTypes(updatedFileTypes);
                      }}
                    >
                      allDocumentDefinitions

                      {allDocumentDefinitions && allDocumentDefinitions.length > 0 ? (
                                    allDocumentDefinitions.map((country, index) => (
                                      <option
                                        key={`${country.id}-${index}`}
                                        value={country.id}
                                      >
                                        {country.txtName}
                                      </option>
                                    ))
                                  ) : (
                                    <option value="">No Fie type</option>
                                  )}
                      <option value="" disabled>
                        Select File Type
                      </option>
                      {/* <option value="Type 1">Type 1</option>
                      <option value="Type 2">Type 2</option> */}
                      {/* Add more file type options as needed */}
                    </select>
                    <button
                      className="btn btn-icon ml-4"
                      onClick={() => removeFile(file, index)}
                    >
                      <FiX />
                    </button>
                  </li>
                ))}
              </ul>
              {(!uploadedFiles || uploadedFiles.length < 4) && (
                <div {...getRootProps()} className="dropzone">
                  <input {...getInputProps()} />
                  <p>Drag 'n' drop some files here, or click to select files</p>
                </div>
              )}
            </div>
            <div className="flex justify-end">
              <button className="btn btn-text mr-6" onClick={onClose} disabled={isLoading}>
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handleSubmit(onSubmit)}
              >
                {isLoading ? <LoadingSpinner /> : "Save"}
              </button>
            </div>
          </div>
        </Modal>
      ) : (
        <SuccessModal showModal={showSuccessModal} onClose={toggleSuccessModal} note={"Employer has been changed"} />
      )}
    </>
  );
};

export default ChangeEmployerBranch;
